import { GoogleAuthProvider, signInWithCredential } from 'firebase/auth';
import { auth } from './firebase';
import { apiFetch } from './api';

// Shared by index.js's bootstrap (One Tap on first load) and SHOP-209's
// private-mode screen (an explicit button - see initGoogleSignIn below for
// why One Tap alone isn't enough there).
export function loadGoogleIdentityScript() {
  return new Promise((resolve, reject) => {
    if (document.getElementById('google-identity-script')) {
      resolve();
      return;
    }

    const script = document.createElement('script');
    script.id = 'google-identity-script';
    script.src = 'https://accounts.google.com/gsi/client';
    script.async = true;
    script.defer = true;

    script.onload = resolve;
    script.onerror = reject;

    document.head.appendChild(script);
  });
}

function handleGoogleCredentialResponse(response, { onSuccess, onError } = {}) {
  const credential = GoogleAuthProvider.credential(response.credential);

  // Returning the chain is harmless for Google's own callback (it ignores
  // the return value) and lets tests await this deterministically.
  return signInWithCredential(auth, credential)
    .then(() => apiFetch('/auth/last-access', { method: 'POST' }))
    .then(() => onSuccess?.())
    .catch(err => {
      console.error('Google sign-in error', err);
      onError?.(err);
    });
}

// Without a buttonContainer, shows the One Tap prompt (index.js's bootstrap
// use). With one, renders Google's own sign-in button into it instead -
// needed by SHOP-209's private-mode screen, since bootstrap only calls this
// for visitors who aren't already a Google user, but a demo_mode block can
// also hit someone already signed in with a *different*, non-allowlisted
// Google account, who still needs a way to pick another one.
export function initGoogleSignIn({ buttonContainer, onSuccess, onError } = {}) {
  if (!window.google?.accounts?.id) return;

  window.google.accounts.id.initialize({
    client_id: process.env.REACT_APP_GOOGLE_CLIENT_ID,
    callback: (response) => handleGoogleCredentialResponse(response, { onSuccess, onError }),
    auto_select: false,
    itp_support: true,
  });

  if (buttonContainer) {
    window.google.accounts.id.renderButton(buttonContainer, {
      type: 'standard',
      theme: 'outline',
      size: 'large',
    });
  } else {
    window.google.accounts.id.prompt();
  }
}
